import {Component, input, signal} from '@angular/core';
import {ComponentEntity, TypeComponent} from "../../entities/component-entity";
import {TextComponent} from "../components/text/text.component";
import {PositionDirective} from "../../directives/position.directive";
import {ButtonImageComponent} from "../components/buttom-image/button-image.component";
import {CarouselComponent} from "../components/carrousel-view/carousel/carousel.component";
import {ImageComponent} from "../components/image/image.component";
import {ButtonComponent} from "../components/button/button.component";
import {ActivatedRoute, Router} from "@angular/router";
import {CacheService} from "../../services/cache.service";
import {ApplicantProject, ApplicantProjectLayout} from "../../entities/projects.entities";
import {VideoComponent} from "../components/video/video.component";
import {MatDialog} from "@angular/material/dialog";
import {DialogVideoComponent} from "../../dialog-video/dialog-video.component";

@Component({
  selector: 'app-view',
  standalone: true,
  imports: [
    TextComponent,
    PositionDirective,
    ButtonImageComponent,
    CarouselComponent,
    ImageComponent,
    ButtonComponent,
    VideoComponent
  ],
  templateUrl: './view.component.html',
  styleUrl: './view.component.css'
})
export class ViewComponent {

  components = signal<ComponentEntity[]>([])

  constructor(private route: ActivatedRoute,private cacheService:CacheService,private dialog: MatDialog) {

    let uuidView = this.route.snapshot.paramMap.get('id')

    let views = this.cacheService.get(CacheService.VIEWS) as ApplicantProjectLayout[]
    let app = this.cacheService.get(CacheService.APP_INFORMATION) as ApplicantProject
    let mainView =
      views.find(view => {
        return view.id === uuidView;
      })

    if(mainView?.mainView && app.preconfiguration.welcomeVideo !== ""){
      this.dialog.open(DialogVideoComponent, {
        width: '800px',
        data: { videoUrl: app.preconfiguration.welcomeVideo } // URL del video
      });
    }
    this.components.set(mainView?.component ??[])

  }


  protected readonly TypeComponent = TypeComponent;
}
